import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'whats-new',
    name: 'support-whats-new',
    component: () => import('./views/WhatsNewList.view.vue'),
  },
  {
    path: 'whats-new/:key',
    name: 'support-whats-new-article',
    component: () => import('./views/WhatsNewArticle.view.vue'),
  },
];
